import Message from '@/components/misc/mixinsComp/Message'
import { msgTypes } from '@/const'
import { groupBy } from '@/utils'

const { INFO, WARN, ERROR, SUCCESS } = msgTypes

const messageMixin = {
  data() {
    return {
      messages: []
    }
  },
  methods: {
    resetMessages() {
      // Clears off alerts messages
      this.messages = []
      this.errors.clear()
    },
    resetValidator() {
      // Reset the validator and clears off all errors (including field validation)
      // Works for reset form
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.reset()
        this.$validator.resume()
      })
    },
    promptFieldCheck() {
      this.$snotify.error('Please check your form input')
    },
    infoMessage(message) {
      this.messages.push({
        type: INFO,
        message: message
      })
    },
    successMessage(message) {
      this.messages.push({
        type: SUCCESS,
        message: message
      })
    },
    warnMessage(message) {
      this.messages.push({
        type: WARN,
        message: message
      })
    },
    errorMessage(message) {
      this.messages.push({
        type: ERROR,
        message: message
      })
    },
    /**
     * This method only prints out messages from "messages" object
     * @param {*} data: Pass in the object standard json format (that was return from the server)
     */
    message(data) {
      this.resetMessages()
      if (data && data.messages) {
        data.messages.map((value, index) => {
          if (value.type && value.message) {
            if (value.type === INFO) {
              this.infoMessage(value.message)
            } else if (value.type === SUCCESS) {
              this.successMessage(value.message)
            } else if (value.type === WARN) {
              this.warnMessage(value.message)
            } else if (value.type === ERROR) {
              this.errorMessage(value.message)
            }
          }
        })
      }
    },
    /**
     * This method prints out messages from "messages and fieldMessages" object
     * @param {*} data: Pass in the object standard json format (that was return from the server)
     */
    fullMessage(data) {
      this.resetMessages()
      if (data && data.messages) {
        data.messages.map((value, index) => {
          if (value.type && value.message) {
            if (value.type === INFO) {
              this.infoMessage(value.message)
            } else if (value.type === SUCCESS) {
              this.successMessage(value.message)
            } else if (value.type === WARN) {
              this.warnMessage(value.message)
            } else if (value.type === ERROR) {
              this.errorMessage(value.message)
            }
          }
        })
      }
      if (data && data.fieldMessages) {
        data.fieldMessages.map((field, index) => {
          let result = field.field + ': '
          const { message } = field
          if (message.type && message.message) {
            if (message.type === INFO) {
              this.infoMessage(result + message.message)
            } else if (message.type === SUCCESS) {
              this.successMessage(result + message.message)
            } else if (message.type === WARN) {
              this.warnMessage(result + message.message)
            } else if (message.type === ERROR) {
              this.errorMessage(result + message.message)
            }
          }
        })
      }
    },
    /**
     * This method sort out the errors and display them to individual fields (make sure the field name is the same as what was passed to the server)
     * @param {*} data: Pass in the object standard json format (that was return from the server)
     * @param {*} showone: pass in true if you only want display 1 error per field
     */
    fieldMessage(data, showone = true) {
      const errorBag = this.$validator.errors
      if (data && data.fieldMessages && errorBag) {
        // There might be more than 1 validation message for a single field
        // We will consolidate the messages before displaying
        const consolidatedMessages = groupBy(data.fieldMessages, message => message.field)
        for (let messages of consolidatedMessages) {
          const [key, value] = messages
          // Split the messages into string array
          let errorMessages = []
          value.map(message => {
            errorMessages.push(message.message.message)
          })
          if (errorMessages.length > 0) {
            const error = {
              field: key,
              msg: showone ? errorMessages[0] : errorMessages.join(', ')
            }
            errorBag.add(error)
          }
        }
      }
    },
    notify(obj) {
      if (obj && obj.messages) {
        obj.messages.map((value, index) => {
          if (value.type && value.message) {
            if (value.type === INFO) {
              this.$snotify.info(value.message)
            } else if (value.type === SUCCESS) {
              this.$snotify.success(value.message)
            } else if (value.type === WARN) {
              this.$snotify.warning(value.message)
            } else if (value.type === ERROR) {
              this.$snotify.error(value.message)
            }
          }
        })
      }
    }
  },
  components: {
    Message
  }
}

export default messageMixin
